import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { WidgetItem } from '@pages/organizer/Widgets/store/widget-types';

export enum UpdateOnPageKeysEnum {
  calendar = 'calendar',
  documents = 'documents',
  contacts = 'contacts',
}

const initialState = {
  isViewWidgets: false,
  isLoadedWidgets: false,
  widgets: [] as WidgetItem[],
  hubTags: [] as number[],
  updateOnPageKeys: {
    documents: false,
    calendar: false,
    contacts: false,
  },
};

const widgetSlice = createSlice({
  name: 'widgetSlice',
  initialState,
  reducers: {
    setWidgets: (state, action: PayloadAction<{ widgets: WidgetItem[] }>) => {
      state.widgets = action.payload.widgets;
    },
    setUpdateOnPageKey: (state, action: PayloadAction<{ key: UpdateOnPageKeysEnum; value: boolean }>) => {
      state.updateOnPageKeys[action.payload.key] = action.payload.value;
    },
    setHubWidgetTags: (state, action: PayloadAction<{ tags: number[] }>) => {
      state.hubTags = action.payload.tags;
    },
    loadedWidget: (state, action: PayloadAction<{ loaded: boolean }>) => {
      state.isLoadedWidgets = action.payload.loaded;
    },

    toggleWidgetPanel: (state, action: PayloadAction<{ isViewWidgets: boolean }>) => {
      state.isViewWidgets = action.payload.isViewWidgets;
    },
    resetWidgetsState: () => {
      return { ...initialState };
    },
  },
});

export const agendaReducer = widgetSlice.reducer;

export const {
  setUpdateOnPageKey,
  toggleWidgetPanel,
  setWidgets,
  loadedWidget,
  setHubWidgetTags,
  resetWidgetsState,
} = widgetSlice.actions;
